import React from 'react';
import dayjs from 'dayjs';
import Link from 'next/link';
import PropTypes from 'prop-types';
import Button from '@/components/Button';
import ContentstackImage from '@/components/ContentstackImage';
import { useTranslation } from '@/hooks/translation';
import { articleType } from '@/types';
import { articleImage } from '@/utilities/articles/articleCard';
import styles from './article.module.scss';

export function ArticleListItem(props) {
  const { article, className, ...extraProps } = props;
  const { t } = useTranslation();

  function articleDate() {
    return dayjs(article?.publish_details.time).format('MM/DD/YYYY')
  }

  return (
    <Link href={`/articles/${article.article_category}${article.url}`}>
      <a className={styles.articleListLink}>
        <div className={`${styles.articleList} d-flex align-items-center justify-content-between`}>
          <div className={styles.info}>
            <h4 className="mb-1">{article.title}</h4>
            <p>
              {`${t('articles.published')} ${articleDate()}`}
            </p>
            <div className={`${styles.button} text-capitalize`}>
              {t(`articles.categories.${article.article_category}`)}
            </div>
          </div>
          <div className={styles.imageWrapper}>
            <ContentstackImage
              src={articleImage(article)}
              alt={t('articles.article_image')}
              className={styles.articleImage}
              width={300}
            />
          </div>
        </div>
      </a>
    </Link>
  );
};

ArticleListItem.propTypes = {
  className: PropTypes.string,
  article: articleType,
};
